"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PartnerCard = void 0;
require("core-js/modules/es.symbol.description.js");
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const PartnerCard = props => {
  const {
    imageUrl,
    name,
    description,
    learnMore
  } = props;
  return /*#__PURE__*/_react.default.createElement("li", {
    className: "con-partner-card"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "con-partner-image__container"
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "con-partner-image__src",
    src: imageUrl,
    alt: "".concat(name, " logo")
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "con-partner-text"
  }, /*#__PURE__*/_react.default.createElement("h3", {
    className: "con-heading__m--centered"
  }, name), /*#__PURE__*/_react.default.createElement("p", {
    className: "con-text__xs--centered"
  }, description), /*#__PURE__*/_react.default.createElement("p", {
    className: "con-text__xs--centered"
  }, learnMore && learnMore.textBefore), /*#__PURE__*/_react.default.createElement("a", {
    className: "con-link__partners--centered",
    href: learnMore && learnMore.url
  }, learnMore && learnMore.url), /*#__PURE__*/_react.default.createElement("p", {
    className: "con-text__xs--centered"
  }, learnMore && learnMore.textAfter), /*#__PURE__*/_react.default.createElement("a", {
    className: "con-link__partners--centered",
    href: learnMore && learnMore.email
  }, learnMore && learnMore.email), /*#__PURE__*/_react.default.createElement("p", {
    className: "con-text__xs--centered"
  }, learnMore && learnMore.textEnd)));
};
exports.PartnerCard = PartnerCard;
PartnerCard.propTypes = {
  imageUrl: _propTypes.default.string,
  name: _propTypes.default.string,
  description: _propTypes.default.string,
  learnMore: _propTypes.default.shape({
    textBefore: _propTypes.default.string,
    url: _propTypes.default.string,
    textAfter: _propTypes.default.string,
    email: _propTypes.default.string,
    textEnd: _propTypes.default.string
  })
};